import { provider } from "@grassrootly/api/providers";

export type GetPlayerFormPayload = { pid: number };
export type PlayerFormRow = {
  player_id: number;
  name: string | null;
  outcome_streak: string | null; // space-separated in chronological order
  ratings: string | null; // space-separated in chronological order
};

export const GetPlayerForm = async (
  params: GetPlayerFormPayload
): Promise<PlayerFormRow | null> => provider.Request("/player-form", params);
